<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <template>
        <!-- <v-treeview :items="items"></v-treeview>
        <v-btn color="blue" dark small fab @click="refresh()">
          <v-icon>refresh</v-icon>
        </v-btn> -->
      </template>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueLodash from "vue-lodash";

const options = { name: "lodash" };
export default {
  components: {},
  data() {
    return {};
  },

  computed: {
    items() {
      return [
        {
          id: 22013,
          name: "11",
          description: null,
          children: [
            {
              id: 22014,
              name: "как дела?",
              orderfield: 1,
              selfAnswer: null,
              answers: [
                {
                  id: 22015,
                  value: "ХОРОШО",
                  orderfield: 1
                },
                {
                  id: 22016,
                  value: "ПЛОХО",
                  orderfield: 2
                },
                {
                  id: 22017,
                  value: "НОРМАЛЬНО",
                  orderfield: 3
                }
              ]
            }
          ]
        },
        {
          id: 23674,
          name: "Опрос для 3 курса",
          description:
            "Уважаемый студент! В этом учебном году Вы участвовали в лекции о средствах гигиены полости рта брендов Oral-B/ Blend-a-Med. Мы благодарим Вас за участие и просим ответить на несколько вопросов о Ваших впечатлениях и опыте использования полуенных образцов продукции. Спасибо за Ваш отзыв! ",
          children: [
            {
              id: 23675,
              name:
                "Пожалуйста, оцените лекцию о средствах гигиены полости рта Oral-B и Blend-a-Med.",
              orderfield: 1,
              selfAnswer: null,
              answers: [
                {
                  id: 23676,
                  value: "Отлично",
                  orderfield: 1
                },
                {
                  id: 23677,
                  value: "Хорошо",
                  orderfield: 2
                },
                {
                  id: 23678,
                  value: "Удовлетворительно",
                  orderfield: 3
                },
                {
                  id: 23679,
                  value: "Плохо",
                  orderfield: 4
                }
              ]
            },
            {
              id: 23680,
              name:
                "Насколько информация, представленная в лекции, полезна для Вашей будущей стоматологической практики?",
              orderfield: 2,
              selfAnswer: null,
              children: [
                {
                  id: 23681,
                  value: "Очень полезна",
                  orderfield: 1
                },
                {
                  id: 23682,
                  value: "Полезна",
                  orderfield: 2
                },
                {
                  id: 23683,
                  value: "Затрудняюсь ответить",
                  orderfield: 3
                },
                {
                  id: 23684,
                  value: "Мне не нужна эта информация",
                  orderfield: 4
                }
              ]
            },
            {
              id: 23685,
              name:
                "Начали ли Вы использовать зубную щетку Oral-B, полученную посде лекции?",
              orderfield: 3,
              selfAnswer: null,
              children: [
                {
                  id: 23686,
                  value: "Да",
                  orderfield: 1
                },
                {
                  id: 23687,
                  value: "Нет",
                  orderfield: 2
                }
              ]
            },
            {
              id: 23688,
              name:
                "Будете ли Вы рекомендовать зубные щетки Oral-B своим пациентам?",
              orderfield: 4,
              selfAnswer: null,
              children: [
                {
                  id: 23689,
                  value: "Абсолютно точно буду",
                  orderfield: 1
                },
                {
                  id: 23690,
                  value: "Скорее всего буду",
                  orderfield: 2
                },
                {
                  id: 23691,
                  value: "Затрудняюсь ответить",
                  orderfield: 3
                },
                {
                  id: 23692,
                  value: "Скорее всего не буду",
                  orderfield: 4
                }
              ]
            },
            {
              id: 23693,
              name:
                "Начали ли Вы использовать зубную пасту Blend-a-Med, полученную посде лекции?",
              orderfield: 5,
              selfAnswer: null,
              children: [
                {
                  id: 23694,
                  value: "Да",
                  orderfield: 1
                },
                {
                  id: 23695,
                  value: "Нет",
                  orderfield: 2
                }
              ]
            },
            {
              id: 23696,
              name:
                "Будете ли Вы рекомендовать зубную пасту Blend-a-Med своим пациентам?",
              orderfield: 6,
              selfAnswer: null,
              children: [
                {
                  id: 23697,
                  value: "Абсолютно точно буду",
                  orderfield: 1
                },
                {
                  id: 23698,
                  value: "Скорее всего буду",
                  orderfield: 2
                },
                {
                  id: 23699,
                  value: "Затрудняюсь ответить ",
                  orderfield: 3
                },
                {
                  id: 23700,
                  value: "Скорее всего не буду",
                  orderfield: 4
                }
              ]
            }
          ]
        },
        {
          id: 23701,
          name: "Опрос для 5 курса ВУЗов и гигиенистов",
          description:
            "Уважаемый студент! В этом учебном году Вы участвовали в лекции о средствах гигиены полости рта брендов Oral-B/ Blend-a-Med. Мы благодарим Вас за участие и просим ответить на несколько вопросов о Ваших впечатлениях и опыте использования полученной электрической зубной щетки Oral-B. Спасибо за Ваш отзыв!",
          children: [
            {
              id: 23702,
              name:
                "Пожалуйста, оцените лекцию по средствам гигиены полости рта Oral-B/Blend-a-Med.",
              orderfield: 1,
              selfAnswer: null,
              children: [
                {
                  id: 23703,
                  value: "Отлично",
                  orderfield: 1
                },
                {
                  id: 23704,
                  value: "Хорошо",
                  orderfield: 2
                },
                {
                  id: 23705,
                  value: "Удовлетворительно",
                  orderfield: 3
                },
                {
                  id: 23706,
                  value: "Плохо",
                  orderfield: 4
                }
              ]
            },
            {
              id: 23707,
              name:
                "Насколько информация, полученная на лекции, может быть полезна для Вашей будущей практики?",
              orderfield: 2,
              selfAnswer: null,
              answers: [
                {
                  id: 23708,
                  value: "Очень полезна",
                  orderfield: 1
                },
                {
                  id: 23709,
                  value: "Полезна",
                  orderfield: 2
                },
                {
                  id: 23710,
                  value: "Затрудняюсь ответить",
                  orderfield: 3
                },
                {
                  id: 23711,
                  value: "Мне не нужна эта информация",
                  orderfield: 4
                }
              ]
            },
            {
              id: 23712,
              name:
                "Как бы Вы оценили способность электрической зубной щетки Oral-B удалять зубной налет в сравнении с мануальной щеткой?",
              orderfield: 3,
              selfAnswer: null,
              answers: [
                {
                  id: 23713,
                  value:
                    "Электрическая щетка Oral-B лучше удаляет налет в сравнении с мануальной",
                  orderfield: 1
                },
                {
                  id: 23714,
                  value:
                    "Электрическая щетка Oral-B также эффективно удаляет налет как и мануальная",
                  orderfield: 2
                },
                {
                  id: 23715,
                  value:
                    "Электрическая щетка Oral-B хуже удаляет налет в сравнении с мануальной",
                  orderfield: 3
                }
              ]
            },
            {
              id: 23716,
              name:
                "Как бы Вы оценили бережность воздействия электрической зубной щетки Oral-B  на мягкие и твердые ткани полости рта в сравнении с мануальной щеткой?",
              orderfield: 4,
              selfAnswer: null,
              answers: [
                {
                  id: 23717,
                  value:
                    "Электрическая щетка Oral-B более бережно воздействует на ткани полости рта в сравнении с мануальной",
                  orderfield: 1
                },
                {
                  id: 23718,
                  value:
                    "Электрическая щетка Oral-B также бережно воздействует на ткани полости рта, как и мануальная",
                  orderfield: 2
                },
                {
                  id: 23719,
                  value:
                    "Электрическая щетка Oral-B менее бережно воздействует на ткани полости рта в сравнении с мануальной",
                  orderfield: 3
                }
              ]
            },
            {
              id: 23720,
              name:
                "Начали ли Вы использовать электрическую зубную щетку Oral-B, полученную после лекции?",
              orderfield: 5,
              selfAnswer: null,
              answers: [
                {
                  id: 23721,
                  value: "Да",
                  orderfield: 1
                },
                {
                  id: 23722,
                  value: "Нет",
                  orderfield: 2
                }
              ]
            },
            {
              id: 23723,
              name:
                "Будете ли Вы рекомендовать электрическую зубную щетку Oral-B своим будущим пациентам?",
              orderfield: 6,
              selfAnswer: null,
              answers: [
                {
                  id: 23724,
                  value: "Абсолютно точно буду",
                  orderfield: 1
                },
                {
                  id: 23725,
                  value: "Скорее всего буду",
                  orderfield: 2
                },
                {
                  id: 23726,
                  value: "Затрудняюсь ответить",
                  orderfield: 3
                },
                {
                  id: 23727,
                  value: "Скорее всего не буду",
                  orderfield: 4
                }
              ]
            }
          ]
        }
      ];
    }
  },

  mounted: function() {},

  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/pages/ui/Alidi.vue